import {
  Button, forwardRef, HStack, Input, Popover, PopoverContent, PopoverTrigger,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import useDebounce from '../../helpers/useDebounce';

const ColorInput = forwardRef((props, ref) => (
  <HexColorInput prefixed alpha color={props.value} {...props} ref={ref} />
));

const ColorPicker = ({ color, onChange }) => {
  const [c, setC] = useState(color);

  const debouncedRequest = useDebounce(() => {
    onChange(c);
  });

  const setColor = (value) => {
    setC(value);
    debouncedRequest();
  };

  useEffect(() => {
    setC(color || '#ffffffff');
  }, [color]);
  return (
    <VStack>
      <Popover>
        <PopoverTrigger>
          <Button bg={c} size="xs" border="1px solid" borderColor="gray.600" />
        </PopoverTrigger>
        <PopoverContent
          w="216px"
          p="2"
          sx={{
            '.react-colorful__hue-pointer': {
              borderRadius: 3,
              width: 4,
            },
          }}
        >
          <HexAlphaColorPicker color={c} onChange={setColor} />
          <HStack mt="2">
            <Text fontSize="xs">HEX:</Text>
            <Input as={ColorInput} value={c} onChange={setColor} />
          </HStack>
        </PopoverContent>
      </Popover>
    </VStack>
  );
};
export default ColorPicker;
